import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useEndTeleconsultation = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (consultationId: string) => {
      return api.post(`teleconsultation/${consultationId}/end`);
    },

    onError: (res: any) => {
      console.error("[From End Teleconsultation]", res);

      handleErrors(res, "mutation");
    },
  });
};
